import type { TypedDocumentNode } from '@apollo/client';
import { gql, useLazyQuery } from '@apollo/client';

import type { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { monetaryAmountFragment } from '@sorare/core/src/lib/monetaryAmount';

import type {
  RefreshCartPriceAndSignedAmount,
  RefreshCartPriceAndSignedAmountVariables,
} from './__generated__/useRefreshCartPriceAndSignedAmount.graphql';

const REFRESH_CART_PRICE_AND_SIGNED_AMOUNT_QUERY = gql`
  query RefreshCartPriceAndSignedAmount($sport: Sport!) {
    currentUser {
      slug
      myCart(sport: $sport) {
        id
        signedAmount
        price {
          ...MonetaryAmountFragment_monetaryAmount
        }
      }
    }
  }
  ${monetaryAmountFragment}
` as TypedDocumentNode<
  RefreshCartPriceAndSignedAmount,
  RefreshCartPriceAndSignedAmountVariables
>;

export const useRefreshCartPriceAndSignedAmount = (sport: Sport) => {
  const [refresh] = useLazyQuery<
    RefreshCartPriceAndSignedAmount,
    RefreshCartPriceAndSignedAmountVariables
  >(REFRESH_CART_PRICE_AND_SIGNED_AMOUNT_QUERY, {
    variables: {
      sport,
    },
    fetchPolicy: 'network-only',
  });

  return { refresh };
};
